import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { getVehiclePlate } from "../helpers";
import { VehicleWizardSceneProps } from "../types";

/** Korak "Osnovne informacije": registracija, VIN, kilometraža i tehnički podaci. */
const InfoScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const km = vehicleInfo.kmTraveled ?? VEHICLE_WIZARD_SAMPLE.km;
  const powerKw = vehicleInfo.maximumPowerKw ?? VEHICLE_WIZARD_SAMPLE.powerKw;

  const specs = [
    { label: "Gorivo", value: vehicleInfo.fuelType || VEHICLE_WIZARD_SAMPLE.fuel },
    { label: "Mjenjač", value: vehicleInfo.transmission || VEHICLE_WIZARD_SAMPLE.transmission },
    { label: "Snaga", value: `${powerKw} kW` },
    { label: "Vrata / sjedala", value: `${vehicleInfo.numberOfDoors || 5} / ${vehicleInfo.seats || 5}` },
  ];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Registracija</div>
          {/* Hrvatska tablica: plava traka s oznakom HR lijevo. */}
          <div className="mt-2 flex items-stretch h-10 rounded-md border-2 border-slate-800 overflow-hidden">
            <span className="flex items-end justify-center w-6 pb-1 bg-blue-700 text-[0.55rem] font-bold text-white">
              HR
            </span>
            <span className="flex flex-1 items-center justify-center text-lg font-bold tracking-widest text-slate-800">
              {getVehiclePlate(vehicleInfo)}
            </span>
          </div>

          <div className="mt-4 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">
            Broj šasije (VIN)
          </div>
          <div className="mt-1 font-mono text-xs tracking-wider text-slate-700">
            {vehicleInfo.vinNumber || VEHICLE_WIZARD_SAMPLE.vin}
          </div>

          <div className="mt-4 flex items-end justify-between border-t border-slate-100 pt-3">
            <span className="text-[0.7rem] text-slate-400">Kilometraža</span>
            <span className="text-xl font-bold text-slate-800">{km.toLocaleString("hr-HR")} km</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Tehnički podaci</div>
          <div className="mt-3 grid grid-cols-2 gap-2">
            {specs.map((spec) => (
              <div key={spec.label} className="rounded-md bg-slate-50 px-2 py-1.5">
                <div className="text-[0.6rem] text-slate-400">{spec.label}</div>
                <div className="text-[0.65rem] font-semibold text-slate-700 truncate">{spec.value}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Obavezna polja"
          subtitle="VIN, registracija i kilometraža"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 3v18M4.2 7.5l15.6 9M19.8 7.5l-15.6 9" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(InfoScene);
